
import CloseIcon from '@mui/icons-material/Close';
import {AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
//import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
//import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useWindowSize from '../../hooks/useWindowSize';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
//import useUtilities from '../../hooks/useUtilities';
import { TextFieldComponent,Transition} from '../shared/ReusableSmallComponents';

function DialogRejetIntteruption({missionId,openDialogRejet,dateEffective,handleCloseDialogRejet,handleCloseDialogWithChangesTable}) {
    DialogRejetIntteruption.propTypes = {
        openDialogRejet: PropTypes.any,
        handleCloseDialogRejet: PropTypes.func,
        dateEffective:PropTypes.any,
        missionId:PropTypes.any,
        handleCloseDialogWithChangesTable:PropTypes.func,
    };

    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    //const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage } = useUtilities();
    const { i18n } = useTranslation();
    const axiosPrivate = useAxiosPrivate();
    const {device}=useWindowSize();
    const [motifRejet,setMotifRejet]=useState('');

    const rejeterDemande = async () => {

        try {
            const response1 = await axiosPrivate.post('mission/traiterInterruptionOrAnnulerMission',
                { missionId : missionId, wasAccepted:false, motifRejet :motifRejet, dateEffective:dateEffective },
            );

            console.log({response1});
            handleCloseDialogWithChangesTable();

        } catch (error) {
            console.log(error.response?.status,error.response?.data.error);
        }

    };

    return(
        <Dialog
            open={openDialogRejet}
            onClose={handleCloseDialogRejet}
            fullScreen
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    background: '#FFFFFF',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseDialogRejet}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems:'center' ,minHeight:'900px',height:'100%', paddingBottom: '24px' }}>
                <div className='OrdreMissionFileFrame18'>
                    <h5 className='OrdreMissionFileFrame19'>
                        {i18n.t('Rejeter la demande d\'interruption de mission')}
                    </h5>
                    <div className='OrdreMissionFileFrame20'>
                        <div className='OrdreMissionFileFrame26'>
                            <div className='OrdreMissionFileFrame23'>
                                <p className='OrdreMissionFileFrame24'>{i18n.t('Motif de rejet')} </p>
                            </div>
                            <div className='OrdreMissionFileFrame27'>
                                <TextFieldComponent
                                    name="motifInterr"
                                    multiline
                                    minRows={4}
                                    value={motifRejet}
                                    onChange={(e) => setMotifRejet(e.target.value)}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px'},
                                    }}
                                    style={{width:'100%'}}
                                    autoFocus={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='OrdreMissionFileFrame28'>
                        <Button
                            onClick={handleCloseDialogRejet}
                            variant="text"
                            style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}
                            }}
                        >{i18n.t('Annuler')}</Button>

                        <Button
                            variant="contained"
                            style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}
                            }}
                            onClick={rejeterDemande}
                        >{i18n.t('Envoyer')}</Button>

                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default DialogRejetIntteruption;
